import ResultsBlock from './components/ResultsBlock';
const { createRoot } = wp.element;

const elements = document.querySelectorAll( '[data-name="qec-results"]' );

// We technically don't need this, but due to the messed up / sensitive loading
// timing of Filters / Core, we kinda need this to run AFTER all filters are loaded.
// So this is a poor man's version of this, as the filter components run slightly before this.
jQuery( document ).ready( function() {
	if ( elements.length > 0 ) {
		elements.forEach( element => {
			const root = createRoot( element );
			root.render(
				<ResultsBlock attributes={ JSON.parse( element.dataset.attributes ) } />
			);
		} );
	}
} );
